import { styled, component } from '../../utils/style';

interface AppContainerProps {
	hasStatusBar: boolean;
}

export const AppContainer = styled<AppContainerProps>()(component.div, 'AppContainer')`
	position: fixed;
	top: ${props => props.hasStatusBar ? '20px' : 0};
	left: 0;
	right: 0;
	bottom: 0;
`;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/App/styles.ts